import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteItemJurisdictionCodeMutationAtom = createMutationAtomFactory(
  'settings.itemJurisdictionCodeDelete',
  ({ id }: { id: string }) => ({
    complianceComplianceItemJurisdictionCodeDelete: {
      __args: {
        id,
      },
    },
  }),
);
